import { render, staticRenderFns } from "./SortingLabel.vue?vue&type=template&id=e6d4baa6"
import script from "./SortingLabel.vue?vue&type=script&lang=js"
export * from "./SortingLabel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports